import { Injectable } from '@angular/core';

/**
 * Interface for usecase preview data structure
 */
export interface UsecasePreviewData {
  // Metadata from Step 1 (General Information)
  title?: string;
  description?: string;
  shortDescription?: string;
  accessPolicy?: string;
  industries?: string[];
  organisationTypes?: string[];
  organisation?: string;
  sector?: string;
  resources?: Array<{ name: string; url?: string }>;
  tags?: string[];
  
  // Parsed sections from editor (Step 2)
  sections: Array<{
    title: string;
    content?: string;
    subsections?: Array<{
      subtitle: string;
      points: string[];
    }>;
  }>;
  
  // Flags
  isPreview?: boolean;
  createdAt?: string;
}

/**
 * Service to temporarily store parsed usecase data for preview
 * Used when navigating from usecase creation/editing to detail page
 */
@Injectable({
  providedIn: 'root'
})
export class UsecasePreviewService {
  private previewData: UsecasePreviewData | null = null;

  /**
   * Store parsed usecase data for preview
   */
  setPreviewData(data: UsecasePreviewData): void {
    this.previewData = data;
    console.log('Preview data stored:', this.previewData);
  }

  /**
   * Get and clear preview data (one-time use)
   */
  getPreviewData(): UsecasePreviewData | null {
    const data = this.previewData;
    // Clear after getting (one-time use)
    this.previewData = null;
    return data;
  }

  /**
   * Check if preview data exists
   */
  hasPreviewData(): boolean {
    return this.previewData !== null;
  }

  /**
   * Clear preview data
   */
  clearPreviewData(): void {
    this.previewData = null;
  }
}
